module.exports = __webpack_public_path__ + "static/3-601c9981b32e69dca8b6eb1a251837be.jpg";